import React from 'react';
import { RouteComponentProps } from '@reach/router';

import Pictures from 'containers/Profile/Content/Pictures';
import Information from 'containers/Profile/Content/Information';
import SocialNetworks from 'containers/Profile/Content/SocialNetworks';
import Icon from 'components/Icon';
import IconTypes from 'components/Icon/IconTypes';
import { TabItem } from 'components/Modal/styles';
import messages from './Messages';
import { ContentSettingsTabs, ContentSettingsContainer } from './styles';
import { connect, MapStateToProps } from 'react-redux';
import { isCompanyOwnerOrSupport } from '../../../../store/companies/companiesUtils';
import { RootState } from '../../../../store/store';
import { ICompany } from '../../../../store/companies/companiesTypes';

interface IOwnProps {
  providerId?: number;
}

interface IComponentStates {
  activeTab: ContentSettingsTabsType;
}

interface IStateToProps {
  managingCompany?: ICompany;
  isOwnerOrSupport: boolean;
}

type IComponentProps = IOwnProps & RouteComponentProps & IStateToProps;

type ContentSettingsTabsType =
  | 'generalInformation'
  | 'socialConnections'
  | 'profilePicture';

const ContentSettingsComponents: {
  [whichComponent in ContentSettingsTabsType]: React.ComponentClass<any>;
} = {
  generalInformation: Information,
  socialConnections: SocialNetworks,
  profilePicture: Pictures,
};

const TabIcons: { [key in ContentSettingsTabsType]: IconTypes } = {
  generalInformation: 'align-justify',
  socialConnections: 'link',
  profilePicture: 'image',
};

const restrictedAccessTab = ['generalInformation', 'profilePicture'];

class ContentSettings extends React.PureComponent<
  IComponentProps,
  IComponentStates
> {
  state: IComponentStates = {
    activeTab: 'generalInformation',
  };

  handleSelectTab = (activeTab: ContentSettingsTabsType) => () => {
    this.setState({ activeTab });
  };

  render() {
    const { isOwnerOrSupport, managingCompany } = this.props;
    const RenderedComponent = ContentSettingsComponents[this.state.activeTab];

    const hasGeneralAccess = managingCompany && !isOwnerOrSupport;

    return (
      <ContentSettingsContainer>
        <ContentSettingsTabs>
          {(
            (hasGeneralAccess
              ? Object.keys(ContentSettingsComponents).filter((item) =>
                  restrictedAccessTab.includes(item)
                )
              : Object.keys(ContentSettingsComponents)) as Array<
              keyof typeof ContentSettingsComponents
            >
          ).map((tab) => (
            <TabItem
              key={tab}
              active={this.state.activeTab === tab}
              onClick={this.handleSelectTab(tab)}
            >
              <Icon type={TabIcons[tab]} className="right" />
              {messages[tab]}
            </TabItem>
          ))}
        </ContentSettingsTabs>
        <RenderedComponent
          providerId={this.props.providerId}
          hasGeneralAccess={hasGeneralAccess}
        />
      </ContentSettingsContainer>
    );
  }
}

const mapStateToProps: MapStateToProps<IStateToProps, IOwnProps, RootState> = (
  state,
  ownProps
) => {
  const thisUser = state.thisUser;
  const providers = state.providers;
  const provider = providers.map[Number(ownProps.providerId)];
  const companyId = provider?.data?.managingCompanyId;
  const company = companyId ? state.companies.data[companyId] : undefined;
  const isOwnerOrSupport = company
    ? isCompanyOwnerOrSupport(thisUser, company)
    : false;

  return {
    managingCompany: company,
    isOwnerOrSupport: isOwnerOrSupport,
  };
};

export default connect(mapStateToProps)(ContentSettings);
